var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 126,
    viewBox: "0 0 109 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 54.238,
    cy: 54.238,
    r: 54.238,
    fill: "#D9D9D9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.238 61.9876C45.6776 61.9876 38.738 55.048 38.738 46.4876V32.1358C38.738 31.0667 38.738 30.5321 38.8938 30.1041C39.155 29.3865 39.7202 28.8213 40.4378 28.5601C40.8658 28.4043 41.4004 28.4043 42.4695 28.4043H66.0065C67.0756 28.4043 67.6102 28.4043 68.0382 28.5601C68.7558 28.8213 69.321 29.3865 69.5822 30.1041C69.738 30.5321 69.738 31.0667 69.738 32.1358V46.4876C69.738 55.048 62.7984 61.9876 54.238 61.9876ZM54.238 61.9876V69.7376M69.738 33.571H76.1963C77.4 33.571 78.0019 33.571 78.4766 33.7676C79.1096 34.0298 79.6125 34.5327 79.8747 35.1657C80.0713 35.6404 80.0713 36.2423 80.0713 37.446V38.7376C80.0713 41.1401 80.0713 42.3413 79.8073 43.3268C79.0906 46.0013 77.0016 48.0903 74.3272 48.8069C73.3416 49.071 72.1404 49.071 69.738 49.071M38.738 33.571H32.2797C31.076 33.571 30.4741 33.571 29.9994 33.7676C29.3664 34.0298 28.8635 34.5327 28.6013 35.1657C28.4047 35.6404 28.4047 36.2423 28.4047 37.446V38.7376C28.4047 41.1401 28.4047 42.3413 28.6687 43.3268C29.3854 46.0013 31.4744 48.0903 34.1488 48.8069C35.1344 49.071 36.3356 49.071 38.738 49.071M42.4695 80.071H66.0065C66.6406 80.071 67.1547 79.5569 67.1547 78.9228C67.1547 73.85 63.0423 69.7376 57.9695 69.7376H50.5065C45.4337 69.7376 41.3213 73.85 41.3213 78.9228C41.3213 79.5569 41.8354 80.071 42.4695 80.071Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_12318_365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0116 121.476L54.238 120.476L93.4644 121.476V122.425L54.238 123.425L15.0116 122.425V121.476Z",
    fill: "url(#paint0_linear_12318_365)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_12318_365",
    x: 13.0116,
    y: 118.476,
    width: 82.4528,
    height: 6.94922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_12318_365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12318_365",
    x1: 15.0116,
    y1: 121.951,
    x2: 93.4644,
    y2: 121.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0528846,
    stopColor: "#06378F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#85D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932692,
    stopColor: "#06378F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew5);
export default __webpack_public_path__ + "static/media/new-5.84b9e084763e0f42bdedb057a48a47f8.svg";
export { ForwardRef as ReactComponent };